import { MaskedTextbox } from '@policygenius/mortar';
import React, { useContext } from 'react';

import QuestionBox from 'components/QuestionBox';
import ScreenSizeContext from 'contexts/ScreenSize';
import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import styles from '../form-inputs.module.scss';
import { MaskedTextFieldProps } from './types';

type Props = MaskedTextFieldProps & FieldRenderProps<string | number, HTMLInputElement, string>;

const MaskedTextField: React.FC<Props> = ({ input, meta, id, bodyQA, ...props }) => {
  const { isDesktop } = useContext(ScreenSizeContext);

  const _onChange: MaskedTextbox.Props['onChange'] = ({ unmasked }) => input.onChange(unmasked);

  return (
    <div className={styles['field-container']}>
      <MaskedTextbox
        {...input}
        {...props}
        defaultValue={input.value ?? undefined}
        errorMessage={getErrorMessage(meta)}
        id={id ?? input.name}
        onChange={_onChange}
        type={input.type ?? 'text'}
      />
      {bodyQA && isDesktop && meta.active && <QuestionBox {...bodyQA} />}
    </div>
  );
};

export default MaskedTextField;
